import React, { useState } from 'react';
import { Tag } from 'lucide-react';
import {
  Popover as PopoverRoot,
  PopoverTrigger as PopoverTriggerRoot,
  PopoverContent as PopoverContentRoot,
} from '../../../../components/ui/popover';

const Popover = PopoverRoot as React.FC<{ open?: boolean; onOpenChange?: (o: boolean) => void; children?: React.ReactNode }>;
const PopoverTrigger = PopoverTriggerRoot as React.FC<{ asChild?: boolean; children?: React.ReactNode }>;
const PopoverContent = PopoverContentRoot as React.FC<{ className?: string; align?: 'start' | 'center' | 'end'; sideOffset?: number; children?: React.ReactNode }>;

/**
 * Badge cliccabile con popover che elenca le categorie escluse da una
 * relazione di rebrand/similarità. Riusato sia nel MachineDetailModal
 * (tab Elenco) che nella vista Compatibilità.
 */
export function CatEscluseBadge({ cats, testId = 'cat-escluse-badge', showLabel = false }: { cats: string[]; testId?: string; showLabel?: boolean }) {
  const [open, setOpen] = useState(false);
  if (cats.length === 0) return <span className="text-[12px] text-[#5c5c57] font-mono">nessuna</span>;
  const label = showLabel
    ? `${cats.length} categori${cats.length === 1 ? 'a' : 'e'} esclus${cats.length === 1 ? 'a' : 'e'}`
    : String(cats.length);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-1 text-[12px] font-bold bg-amber-50 border
          border-amber-200 text-amber-700 px-1.5 py-0.5 rounded hover:bg-amber-100 transition-colors"
          data-testid={testId} title={`${cats.length} categorie escluse`}>
          <Tag className="w-2.5 h-2.5" />
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-3 w-52" align="start" sideOffset={4}>
        <div className="text-[12px] font-bold text-[#5c5c57] mb-2 uppercase tracking-wider font-mono">
          Categorie escluse
        </div>
        <div className="space-y-1">
          {cats.map(c => <div key={c} className="text-[13px] text-[#3a3a36]">• {c}</div>)}
        </div>
      </PopoverContent>
    </Popover>
  );
}
